import React from 'react';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { GlobalViewTaxForm } from './global-viewtaxform';
import { ViewTaxFormPropTypes } from '../../shapes';

const { CountryCode } = Constants;

export const FJTaxViewTaxForm = props => (
  <GlobalViewTaxForm
    {...props}
    countryCode={CountryCode.FJ}
    showTaxCert={false}
  />
);

FJTaxViewTaxForm.propTypes = ViewTaxFormPropTypes;
